import { render, staticRenderFns } from "./DocTemplateList.vue?vue&type=template&id=3ddfcf88&scoped=true&"
import script from "./DocTemplateList.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./DocTemplateList.vue?vue&type=style&index=0&id=3ddfcf88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfcf88",
  null
  
)

export default component.exports